import React from 'react';
import {  Badge, Button } from "react-bootstrap";
import styles from './KeyDate.module.scss';

interface MilestonesTabProps {
    showAllDates: boolean;
    setShowAllDates: (value: boolean) => void;
    filteredGroups: any[];
    overdueIncompleteTasks: any[];
    renderDateItem: (dayMsg: any) => JSX.Element;
    renderTaskItem: (task: any, index: any, overdueInfo?: any) => JSX.Element;
    renderOverdueTask: (item: any) => JSX.Element;
    renderAppointmentItem: (appointment: any, index: any) => JSX.Element;
}

const MilestonesTab: React.FC<MilestonesTabProps> = ({
    showAllDates,
    setShowAllDates,
    filteredGroups,
    overdueIncompleteTasks,
    renderDateItem,
    renderTaskItem,
    renderOverdueTask,
    renderAppointmentItem
}) => {
    // Check if there's already a "Today" group
    const hasTodayGroup = filteredGroups.some(group => group.isToday);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const todayFormatted = currentDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    
    return (
        <>
            {/* Toggle button for All/Upcoming view */}
            <div style={{ textAlign: showAllDates ? 'right' : 'left'}}>
                <Button 
                    variant="link" 
                    size="sm"
                    onClick={() => setShowAllDates(!showAllDates)}
                >
                    {showAllDates ? 
                        <>
                            View Upcoming Dates
                            <i className={`fa-solid fa-caret-right ms-1`}></i>
                        </> 
                        : 
                        <>
                            <i className={`fa-solid fa-caret-left me-1`}></i>
                            View Previous Dates
                        </>
                    }
                </Button>
            </div>
            
            {/* Overdue incomplete tasks (only in Upcoming view) */}
            {!showAllDates && overdueIncompleteTasks.length > 0 && (
                <>
                    <div className={styles.overdue}>
                        <h4><i className="fa-solid fa-flag-swallowtail me-1 text-danger"></i>Overdue</h4>
                        {overdueIncompleteTasks.map((item, index) => (
                            <div key={`overdue-${index}`} className="options-container">
                                {renderOverdueTask(item)}
                            </div>
                        ))}
                    </div>

                    <hr />
                </>
            )}
            
            {/* Show "Today" even if there are no tasks */}
            {!showAllDates && !hasTodayGroup && (
                <div className={styles.date}>
                    <h5><i className="fa-solid fa-circle text-warning"></i>{todayFormatted} <span className="text-muted small">- Today</span></h5>
                    <p className="text-muted small" style={{marginLeft: '30px'}}>No items for today.</p>
                </div>
            )}
            
            {/* Grouped by date view */}
            {filteredGroups.length === 0 && showAllDates ? (
                <p className="text-muted text-center small mt-4">No tasks found.</p>
            ) : (
                filteredGroups.map((group, groupIndex) => (
                    <div key={`date-group-${groupIndex}`} className={styles.date}>
                        {group.isToday ? (
                            <div style={{marginBottom:'0', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                <h5>{group.formattedDate}</h5>
                                <Badge pill bg="warning-heavy">Today</Badge>
                            </div>
                        ):(
                            <h5>
                                {group.formattedDate}
                            </h5>
                        )}
                        
                        {group.items.length === 0 ? (
                            <p className="text-muted small">No items for this date.</p>
                        ) : (
                            group.items.map((item, itemIndex) => (
                                <div key={`item-${groupIndex}-${itemIndex}`} className="options-container">
                                    {item.type === 'date' 
                                        ? renderDateItem(item.data)
                                        : item.type === 'appointment'
                                        ? renderAppointmentItem(item.data, itemIndex)
                                        : renderTaskItem(item.data, itemIndex)
                                    }
                                </div>
                            ))
                        )}
                    </div>
                ))
            )}
        </>
    );
};

export default MilestonesTab; 